import React, { useEffect, useState } from "react";
import './CreateAccount.css';
import { useSelector } from "react-redux";
import ReactInputMask from "react-input-mask";
import "../../styles/createaccount.css";
import { useNavigate } from "react-router-dom";
import HeaderLogin from "../../components/HeaderLogin";
import { GOOGLE_RECAPTCHA_GETSCORE_API } from "../../creds";
import { getLawFirmInformationService, createNewAccountService, validateEmail } from "../../services/BondsServices";
import { executeRecaptcha } from '../../utils/recaptcha';
import { Col, Form, Row } from "react-bootstrap";
import Footer from "../../components/Footer";

const CreateAccount = () => {

  const [showCaptcha, setShowCaptcha] = useState(false); // State to control when to show CAPTCHA

  const handleVerificationSuccess = () => {
    setShowCaptcha(false); // Hide CAPTCHA on successful verification
    // Proceed with account creation or other actions
  };
  const allQuestions = [
    { id: 1, text: "What was your very first job?" },
    { id: 2, text: "What was the name of your first pet?" },
    {
      id: 3,
      text: "What is the name of the most important person you ever met?",
    },
    { id: 4, text: "What was the year and model of your first car?" },
    { id: 5, text: "What is the name of your first girlfriend/boyfriend?" },
    {
      id: 6,
      text: "What was your childhood phone number including area code?",
    },
    { id: 7, text: "What was the most memorable field trip in school?" },
    { id: 8, text: "As a child what did you want to be when you grew up?" },
  ];
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [nextToggle, setNextToggle] = useState(false);
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [userData, setUserData] = useState({ country: "USA" });
  const [questions, setQuestions] = useState(allQuestions);
  const [allFirms, setAllFirms] = useState([]);
  function setData(name, value) {
    const tempData = userData;
    tempData[name] = value;
    setUserData({ ...tempData });
  }


  useEffect(() => {
    fetchFirmData();
  }, []);

  const fetchFirmData = async () => {
    try {
      const firmResponse = await getLawFirmInformationService();
      console.log(firmResponse);
      setAllFirms(firmResponse);
    } catch (error) {
      console.error("Error fetching law firm data:", error);
    }
  };

  const createNewAccount = async (e, new_account) => {
    setIsLoading(true);
    e.preventDefault();

    try {
      const token = await executeRecaptcha('create_account');
      
      const res = await fetch(GOOGLE_RECAPTCHA_GETSCORE_API, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ recaptchaToken: token }),
      });

      if (!res.ok) {
        throw new Error('Failed to verify reCAPTCHA');
      }

      const data = await res.json();

      if (!data.success) {
        // setMessage('Failed reCAPTCHA validation. Try again.');
        return;
      }

      const { score } = data;

      if (score < 0.5) {
        // setMessage('Suspicious activity detected. Slowing down...');
        await new Promise(resolve => setTimeout(resolve, 10000));
      }


      // Proceed with account creation regardless of score
      try {
        await createNewAccountService(new_account);
        setIsLoading(false);
        setError('');
        setStep(3); // Advance step
      } catch (error) {
        // setError(error.message);
        console.error("Error creating account:", error);
        setError(error.message);
      }

    } catch (err) {
      console.error('reCAPTCHA error:', err);
      setIsLoading(false);
      // setMessage('Something went wrong. Please try again.');
    } finally {
      setIsLoading(false);
      // setSubmitting(false);
    }


  };

  function clickCancel() {
    navigate("/login");
  }

  const clickCreateAccount = async (e) => {
    const emailValid = validateEmail(userData["user_type"], userData["email_address"])
    if (
      userData["email_address"] === undefined ||
      userData["email_address"].trim().length === 0
    ) {
      setError("Email Address can not be blank");
    }
    else if (!emailValid.valid) {
      setError(emailValid.message);
    }
    else if (
      userData["first_name"] === undefined ||
      userData["first_name"].trim().length === 0
    ) {
      setError("First Name can not be blank");
    } else if (
      userData["last_name"] === undefined ||
      userData["last_name"].trim().length === 0
    ) {
      setError("Last Name can not be blank");
    } else if (
      userData["phone_number"] === undefined ||
      userData["phone_number"].trim().length === 0
    ) {
      setError("Phone Number cannot be blank");

    }
    else if (
      userData["phone_number"].replace(/\D/g, '').length < 10
    ) {
      setError("Phone Number cannot be less than 10 digits");

    } else if (
      userData["office_phone"] === undefined ||
      userData["office_phone"].trim().length === 0
    ) {
      setError("Contact Phone cannot be blank");

    }
    else if (
      userData["office_phone"].replace(/\D/g, '').length < 10
    ) {
      setError("Contact Phone cannot be less than 10 digits");

    } else if (
      (userData["user_type"] === "CSL") && (
        userData["law_firm_name"] === undefined ||
        userData["law_firm_name"] === null ||
        userData["law_firm_name"].trim().length === 0
      )

    ) {
      setError("Law Firm Name can not be blank");
    } else if (
      userData["address1"] === undefined ||
      userData["address1"].trim().length === 0
    ) {
      setError("Address can not be blank");
    } else if (
      userData["country"] === undefined ||
      userData["country"].trim().length === 0
    ) {
      setError("Country can not be blank");
    } else if (
      userData["state"] === undefined ||
      userData["state"].trim().length === 0
    ) {
      setError("State can not be blank");
    } else if (
      userData["city"] === undefined ||
      userData["city"].trim().length === 0
    ) {
      setError("City can not be blank");
    } else if (
      userData["zipcode"] === undefined ||
      userData["zipcode"].trim().length === 0
    ) {
      setError("Zip Code can not be blank");
    }
    else {

      const _data = {
        email_address: userData["email_address"],
        FirstName: userData["first_name"],
        LastName: userData["last_name"],
        phone_number: userData["phone_number"].replace(/\D/g, ''),
        user_type: userData["user_type"],
        Law_Firm_Name: userData["law_firm_name"],
        Address1: userData["address1"],
        Address2: userData["address2"],
        City: userData["city"],
        State: userData["state"],
        Country: userData["country"],
        ZipCode: userData["zipcode"],
        office_phone: userData["office_phone"].replace(/\D/g, ''),

      };

      createNewAccount(e, _data);
    }
  }
  return (
    <>




      <HeaderLogin />
      {showCaptcha ? (
        <div className="modal-container">
          {/* <CaptchaPopup onVerificationSuccess={handleVerificationSuccess} /> */}
          {/* <GoogleReCaptchaProvider
            reCaptchaKey = { RECAPTCHA_KEY }
            scriptProps={{ async: true, defer: true }}
          >
            <ReCaptchaComponent onVerify={handleVerify} />
          </GoogleReCaptchaProvider> */}
          {/* <CaptchaPopup onVerificationSuccess={handleVerificationSuccess} /> */}
          {/* <GoogleReCaptchaProvider
            reCaptchaKey = { RECAPTCHA_KEY }
            scriptProps={{ async: true, defer: true }}
          >
            <ReCaptchaComponent onVerify={handleVerify} />
          </GoogleReCaptchaProvider> */}
        </div>
      ) :
        (<div className="content">
          <div className="row mt-4">
            <div className="col-md-2"></div>
            <div className="col-md-10 mb-3">
              <h3>
                {step == 1 ? "User Info" : ""}
                {step == 2 && userData["user_type"] == 0
                  ? "Security Questions"
                  : ""}
                {step == 3 ? "Email Verification" : ""}
              </h3>
              <div className="row">
                <div
                  className={step == 1 ? `col-md-4 ctab active` : "col-md-4 ctab"}
                >
                  <span className="txt_lbl">01</span>
                  <span className="txt_tabname">User Info</span>
                </div>
                {userData["user_type"] == 0 ? (
                  <div
                    className={
                      step == 2 ? `col-md-4 ctab active` : "col-md-4 ctab"
                    }
                  >
                    <span className="txt_lbl">02</span>
                    <span className="txt_tabname">Securty Questions</span>
                  </div>
                ) : (
                  <></>
                )}
                <div
                  className={step == 3 ? `col-md-4 ctab active` : "col-md-4 ctab"}
                >
                  <span className="txt_lbl">
                    {userData["user_type"] == 0 ? "03" : "02"}
                  </span>
                  <span className="txt_tabname">Email Verification</span>
                </div>
              </div>
            </div>
            <div className="col-md-2"></div>
          </div>
          <div className="row mt-4">
            <div className="col-md-4"></div>
            <div className="col-md-4">
              <div className="box-create-account">
                <div className="register-form"></div>
                {error.length ? (
                  <div className="row">
                    {" "}
                    <div className="alert alert-danger mt-3 mb-3">{error}</div>
                  </div>
                ) : (
                  <></>
                )}
                <div className="row mt-3">
                  {step === 1 ? (
                    <div id="step1">
                      <div className="col-md-12 mb-3">
                        <Form.Group as={Row} className="align-items-center mb-3">
                          <Form.Label column sm="3">First Name</Form.Label>
                          <Col sm="9">
                            <input
                              type="text"
                              className="form-control"
                              name="first_name"
                              id="first_name"
                              value={
                                userData["first_name"] ? userData["first_name"] : ""
                              }
                              onChange={(e) => setData("first_name", e.target.value)}
                            />
                          </Col>
                        </Form.Group>
                      </div>
                      <div className="col-md-12 mb-3">
                        <Form.Group as={Row} className="align-items-center mb-3">
                          <Form.Label column sm="3">Last Name</Form.Label>
                          <Col sm="9">
                            <input
                              type="text"
                              className="form-control"
                              name="last_name"
                              value={
                                userData["last_name"] ? userData["last_name"] : ""
                              }
                              onChange={(e) => setData("last_name", e.target.value)}
                            />
                          </Col>
                        </Form.Group>
                      </div>
                      <div className="col-md-12 mb-3">
                        <Form.Group as={Row} className="align-items-center mb-3">
                          <Form.Label column sm="3">Email Address</Form.Label>
                          <Col sm="9">
                            <input
                              type="email"
                              className="form-control"
                              name="email_address"
                              value={
                                userData["email_address"]
                                  ? userData["email_address"]
                                  : ""
                              }
                              onChange={(e) =>
                                setData("email_address", e.target.value)
                              }
                            /></Col>
                        </Form.Group>
                      </div>
                      <div className="col-md-12 mb-3">
                        <Form.Group as={Row} className="align-items-center mb-3">
                          <Form.Label column sm="3">Cell Number</Form.Label>
                          <Col sm="9">
                            <ReactInputMask mask="(999) 999-9999"
                              type="text"
                              className="form-control"
                              name="phone_number"
                              value={
                                userData["phone_number"]
                                  ? userData["phone_number"]
                                  : ""
                              }
                              onChange={(e) =>
                                setData("phone_number", e.target.value)
                              }
                            /></Col>
                        </Form.Group>
                      </div>
                      <div className="col-md-12 mb-3">
                        <Form.Group as={Row} className="align-items-center mb-3">
                          <Form.Label column sm="3">Contact Phone</Form.Label>
                          <Col sm="9">
                            <ReactInputMask mask="(999) 999-9999"
                              type="text"
                              className="form-control"
                              name="office_phone"
                              value={
                                userData["office_phone"]
                                  ? userData["office_phone"]
                                  : ""
                              }
                              onChange={(e) =>
                                setData("office_phone", e.target.value)
                              }
                            /></Col>
                        </Form.Group>
                      </div>
                      <div className="col-md-12 mb-3">
                        <Form.Group as={Row} className="align-items-center mb-3">
                          <Form.Label column sm="3">User Type</Form.Label>
                          <Col sm="9">
                            <select
                              className="form-control"
                              name="user_type"
                              defaultValue={
                                userData["user_type"] ? userData["user_type"] : -1
                              }
                              onChange={(e) => {
                                console.log(e.target.value);
                                if (e.target.value == 2) {
                                  setNextToggle(false);
                                } else {
                                  setNextToggle(false);
                                }
                                setData("user_type", e.target.value);
                                setData("law_firm_name", "");
                              }}
                            >
                              <option value="-1">Select User Type</option>
                              <option value="CSL">Bond Counsel</option>
                              <option value="OAG">Office of Attorney General</option>
                              <option value="BRB">Bond Review Board</option>
                              <option value="MAC">MAC User</option>
                              <option value="TWB">TX Water Development Board </option>
                              <option value="TEA">TX Education Agency </option>
                            </select></Col>
                        </Form.Group>
                      </div>

                      {userData["user_type"] === "CSL" && <div className="col-md-12 mb-3">
                        <Form.Group as={Row} className="align-items-center mb-3">
                          <Form.Label column sm="3">Law Firm</Form.Label>
                          <Col sm="9">
                            <select
                              className="form-control"
                              name="law_firm_name"
                              defaultValue={userData["law_firm_name"] ? userData["law_firm_name"] : ""}
                              onChange={(e) => setData("law_firm_name", e.target.value)}
                            >
                              <option value="">Select Law Firm</option>
                              {allFirms.map((firm, index) => (
                                <option key={index} value={firm}>
                                  {firm}
                                </option>
                              ))}
                            </select></Col>
                        </Form.Group>
                      </div>}
                      <div className="col-md-12 mb-3">
                        <Form.Group as={Row} className="align-items-center mb-3">
                          <Form.Label column sm="3">Address1</Form.Label>
                          <Col sm="9">
                            <input
                              type="text"
                              className="form-control"
                              name="address1"
                              value={userData["address1"] ? userData["address1"] : ""}
                              onChange={(e) => setData("address1", e.target.value)}
                            /></Col>
                        </Form.Group>
                      </div>
                      <div className="col-md-12 mb-3">
                        <Form.Group as={Row} className="align-items-center mb-3">
                          <Form.Label column sm="3">Address2</Form.Label>
                          <Col sm="9">
                            <input
                              type="text"
                              className="form-control"
                              name="address2"
                              value={userData["address2"] ? userData["address2"] : ""}
                              onChange={(e) => setData("address2", e.target.value)}
                            /></Col>
                        </Form.Group>
                      </div>
                      <div className="col-md-12 mb-3">
                        <div className="row">
                          <div className="col-md-12">
                            <Form.Group as={Row} className="align-items-center mb-3">
                              <Form.Label column sm="3">State</Form.Label>
                              <Col sm="9">
                                <select
                                  className="form-control"
                                  name="state"
                                  placeholder=""
                                  defaultValue={
                                    userData["state"] ? userData["state"] : -1
                                  }
                                  onChange={(e) => setData("state", e.target.value)}
                                >
                                  <option value="-1">Select State</option>
                                  <option value="AL">Alabama</option>
                                  <option value="AK">Alaska</option>
                                  <option value="AZ">Arizona</option>
                                  <option value="AR">Arkansas</option>
                                  <option value="CA">California</option>
                                  <option value="CO">Colorado</option>
                                  <option value="CT">Connecticut</option>
                                  <option value="DE">Delaware</option>
                                  <option value="DC">District Of Columbia</option>
                                  <option value="FL">Florida</option>
                                  <option value="GA">Georgia</option>
                                  <option value="HI">Hawaii</option>
                                  <option value="ID">Idaho</option>
                                  <option value="IL">Illinois</option>
                                  <option value="IN">Indiana</option>
                                  <option value="IA">Iowa</option>
                                  <option value="KS">Kansas</option>
                                  <option value="KY">Kentucky</option>
                                  <option value="LA">Louisiana</option>
                                  <option value="ME">Maine</option>
                                  <option value="MD">Maryland</option>
                                  <option value="MA">Massachusetts</option>
                                  <option value="MI">Michigan</option>
                                  <option value="MN">Minnesota</option>
                                  <option value="MS">Mississippi</option>
                                  <option value="MO">Missouri</option>
                                  <option value="MT">Montana</option>
                                  <option value="NE">Nebraska</option>
                                  <option value="NV">Nevada</option>
                                  <option value="NH">New Hampshire</option>
                                  <option value="NJ">New Jersey</option>
                                  <option value="NM">New Mexico</option>
                                  <option value="NY">New York</option>
                                  <option value="NC">North Carolina</option>
                                  <option value="ND">North Dakota</option>
                                  <option value="OH">Ohio</option>
                                  <option value="OK">Oklahoma</option>
                                  <option value="OR">Oregon</option>
                                  <option value="PA">Pennsylvania</option>
                                  <option value="RI">Rhode Island</option>
                                  <option value="SC">South Carolina</option>
                                  <option value="SD">South Dakota</option>
                                  <option value="TN">Tennessee</option>
                                  <option value="TX">Texas</option>
                                  <option value="UT">Utah</option>
                                  <option value="VT">Vermont</option>
                                  <option value="VA">Virginia</option>
                                  <option value="WA">Washington</option>
                                  <option value="WV">West Virginia</option>
                                  <option value="WI">Wisconsin</option>
                                  <option value="WY">Wyoming</option>
                                </select></Col>
                            </Form.Group>
                          </div>
                          <div className="col-md-12">
                            <Form.Group as={Row} className="align-items-center mb-3">
                              <Form.Label column sm="3">City</Form.Label>
                              <Col sm="9">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder=""
                                  name="city"
                                  value={userData["city"] ? userData["city"] : ""}
                                  onChange={(e) => setData("city", e.target.value)}
                                /></Col>
                            </Form.Group>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-12 mb-3">
                        <div className="row">
                          <div className="col-md-12">
                            <Form.Group as={Row} className="align-items-center mb-3">
                              <Form.Label column sm="3">Country</Form.Label>
                              <Col sm="9">
                                <select
                                  className="form-control"
                                  disabled
                                  name="country"
                                  placeholder=""
                                  defaultValue={
                                    userData["country"] ? userData["country"] : -1
                                  }
                                  onChange={(e) => setData("country", e.target.value)}
                                >
                                  <option value="-1">Select Options</option>
                                  <option value="USA">USA</option>
                                </select></Col>
                            </Form.Group>
                          </div>
                          <div className="col-md-12">
                            <Form.Group as={Row} className="align-items-center mb-3">
                              <Form.Label column sm="3">Zip Code</Form.Label>
                              <Col sm="9">
                                <input
                                  className="form-control"
                                  name="zipcode"
                                  value={
                                    userData["zipcode"] ? userData["zipcode"] : ""
                                  }
                                  onChange={(e) => setData("zipcode", e.target.value)}
                                /></Col>
                            </Form.Group>
                          </div>
                        </div>
                      </div>
                      <div>
                        {!isLoading ? 
                        <div className="col-md-12 ">
                          <div className="row">
                            <div className="col-md-6 text-end">
                              <button
                                type="button"
                                class="btn btn-primary btn-lg"
                                onClick={() => clickCancel()}
                              >
                                <div class="ux-btn-label-wrapper">Cancel</div>
                              </button>
                            </div>
                            <div className="col-md-6 text-left">
                              {nextToggle ? (
                                <button
                                  className="btn btn-primary"
                                  onClick={() => setStep(3)}
                                >
                                  Next
                                </button>
                              ) : (
                                <button
                                  id="continueBtn"
                                  type="button"
                                  class="btn btn-primary btn-lg"
                                  onClick={(e) =>  clickCreateAccount(e)}
                                >
                                  <div class="ux-btn-label-wrapper">Submit</div>
                                </button>
                              )}
                            </div>
                          </div>
                      </div> :
                      <div className="col-md-12 ">
                          <div className="row">
                            <div style={{ marginTop: 20, textAlign: 'center' }}>
                              {/* Spinner only */}
                              <div className="spinner" />
                            </div> 
                          </div>
                      </div>
                    }
                    </div>
                    </div>
                  ) : (
                    <div></div>
                  )}

                  {step === 2 ? (
                    <div id="step2">
                      <div className="col-md-12 mb-3">
                        <select
                          className="form-control mb-2"
                          name="question1"
                          label
                          id="Question 1:"
                          placeholder="select an option"
                          onChange={(e) => setData("question1", e.target.value)}
                          defaultValue={"-1"}
                        >
                          <option disabled value="-1">
                            Select Securty Question
                          </option>
                          {questions
                            .filter(
                              (v) =>
                                v.id != userData["question2"] &&
                                v.id != userData["question3"]
                            )
                            .map((item) => {
                              return (
                                <option key={item.id} value={item.id}>
                                  {item.text}
                                </option>
                              );
                            })}
                        </select>
                        <input
                          type="text"
                          className="form-control"
                          name="answer1"
                          value={
                            userData.answer1 !== undefined ? userData.answer1 : ""
                          }
                          onChange={(e) => setData("answer1", e.target.value)}
                        />
                      </div>
                      <div className="col-md-12 row-gaper">
                        <select
                          className="form-control mb-2"
                          name="question2"
                          placeholder="select an option"
                          onChange={(e) => setData("question2", e.target.value)}
                          defaultValue={"-1"}
                        >
                          <option disabled value="-1">
                            Select Securty Question
                          </option>
                          {questions
                            .filter(
                              (v) =>
                                v.id != userData["question1"] &&
                                v.id != userData["question3"]
                            )
                            .map((item) => {
                              return (
                                <option key={item.id} value={item.id}>
                                  {item.text}
                                </option>
                              );
                            })}
                        </select>
                        <input
                          type="text"
                          className="form-control "
                          name="answer2"
                          value={
                            userData.answer2 !== undefined ? userData.answer2 : ""
                          }
                          onChange={(e) => setData("answer2", e.target.value)}
                        />
                      </div>
                      <div className="col-md-12 row-gaper">
                        <select
                          className="form-control mb-2"
                          name="question3"
                          placeholder="select an option"
                          onChange={(e) => setData("question3", e.target.value)}
                          defaultValue={"-1"}
                        >
                          <option disabled value="-1">
                            Select Securty Question
                          </option>
                          {questions
                            .filter(
                              (v) =>
                                v.id != userData["question1"] &&
                                v.id != userData["question2"]
                            )
                            .map((item) => {
                              return (
                                <option key={item.id} value={item.id}>
                                  {item.text}
                                </option>
                              );
                            })}
                        </select>
                        <input
                          type="text"
                          className="form-control"
                          name="answer3"
                          value={
                            userData.answer3 !== undefined ? userData.answer3 : ""
                          }
                          onChange={(e) => setData("answer3", e.target.value)}
                        />
                      </div>
                      <div className="col-md-12 ">
                        <div className="row">
                          <div className="col-md-6">
                            <button
                              className="btn btn-primary"
                              onClick={() => {
                                setStep(1);
                              }}
                            >
                              Back
                            </button>
                          </div>
                          <div className="col-md-6 text-end">
                            <button
                              className="btn btn-primary"
                              onClick={(e) => clickCreateAccount(e)}
                            >
                              Submit
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <></>
                  )}

                  {step === 3 ? (
                    <div id="step3">
                      <div className="col-md-12 ">
                        <div class="alert alert-dark" role="alert">
                          <h4 class="alert-heading">
                            Profile submitted for Review!
                          </h4>
                          <p>
                            You will get notified through email once the profile
                            is approved.
                          </p>
                          <hr />
                          <p class="mb-0">
                            Please follow the instructions mentioned in the email
                            to complete your registration process.
                          </p>
                        </div>
                      </div>
                      <div className="col-md-12 text-left">
                        <button
                          type="button"
                          class="btn btn-primary btn-lg"
                          onClick={() => clickCancel()}
                        >
                          Return to Login
                        </button>
                      </div>
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
            </div>
            <div className="col-md-4"></div>
          </div>
        </div>

        )
      }
      <Footer isLoggedIn="False"></Footer>
    </>
  );
};

export default CreateAccount;
